import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as OperationShopping } from '../assets/svg/Header/OperationShopping.svg'
import { ReactComponent as OperationPicking } from '../assets/svg/Header/OperationPicking.svg'
import { ReactComponent as OperationStock } from '../assets/svg/Header/OperationStock.svg'
import { ReactComponent as OperationCheckList } from '../assets/svg/Header/OperationCheckList.svg'
import { ReactComponent as OperationStatistic } from '../assets/svg/Header/OperationStatistic.svg'
import { ReactComponent as OperationBuyer } from '../assets/svg/Header/OperationBuyer.svg'
import { ReactComponent as OperationOrderHistory } from '../assets/svg/Header/OperationOrderHistory.svg'
import { ReactComponent as OperationVacation } from '../assets/svg/Header/OperationVacation.svg'
import { ReactComponent as OperationLogisticList } from '../assets/svg/Header/OperationLogisticList.svg'

export const operations = [
  {
    permission: site?.avalible?.operations?.shopping,
    link: '/admin/shopping',
    name: `Shopping ${localStorage.getItem('name') === 'TPO' ? '' : 'CCN'}`,
    icon: <OperationShopping width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.shopping,
    // link: '/admin/buyer',
    link: '/buyerList',
    name: `Buyer ${localStorage.getItem('name') === 'TPO' ? '' : 'CCN'}`,
    icon: <OperationBuyer width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: true, // Права теперь проверяются динамически
    link: '/admin/logistic',
    name: 'Lista Entregas',
    icon: (
      <OperationLogisticList
        width={'30px'}
        height={'30px'}
      />
    ),
    enabled: true,
    disabled: false,
  },
  {
    permission: null, // Права теперь проверяются динамически
    link: '/admin/prezo',
    name: 'Prezo Manager',
    icon: (<OperationLogisticList
            width={'30px'}
            height={'30px'}
          />),
    enabled: true,
    disabled: false,
  },
  // {
  //   permission: site?.avalible?.operations?.Partnership,
  //   link: '/admin/shipment',
  //   name: 'Partnership',
  //   icon: <OperationPartnership width={'30px'} height={'30px'} />,
  //   enabled: true,
  //   disabled: false,
  // },
  
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/stock',
    name: 'Stock',
    icon: <OperationStock width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/picking',
    name: 'Picking',
    icon: <OperationPicking width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/searchingList',
    name: 'Searching list',
    icon: <OperationPicking width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/vacations',
    name: 'Vacations',
    icon: <OperationVacation width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: false,
  },
  // {
  //   permission: site?.avalible?.operations?.facturas,
  //   link: '/admin/spoManagement',
  //   name: 'Special Offers',
  //   icon: <OperationSPO width={'30px'} height={'30px'} />,
  //   enabled: true,
  //   disabled: false,
  // },
  //Disabled links Functional Coming soon
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/orders',
    name: 'Check List 🔜',
    icon: <OperationCheckList width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
  {
    permission: site?.avalible?.operations?.facturas,
    link: '/admin/orders',
    name: 'Statistic & Analitica 🔜',
    icon: <OperationStatistic width={'30px'} height={'30px'} />,
    enabled: true,
    disabled: true,
  },
]
